import {
    Component,
    OnInit,
    TemplateRef,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';
import { SiteServices } from '../../services/siteservices';
import { Router } from '@angular/router';
import { ProviderContext } from '../../data/Entities';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { setTimeout } from 'timers';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Helpers } from '../../services/Helpers';

declare var jQuery: any;

@Component({
    selector: 'orderlist',
    templateUrl: '/templates/get/Discount/discount_list',
})
export class DiscountList implements OnInit {
    public current_row: any;
    public groupActionVisible: boolean;
    public groupAction: string;
    public action: string;
    public dtx: ProviderContext;
    public rows: any = [];
    public searchText: string;

    public filterStatusID: string;
    public filterDeliveryTypeID: string;
    public filterCreated: string;
    public filterGen: string;

    constructor(
        public siteServices: SiteServices,
        private modalService: BsModalService,
        public viewRef: ViewContainerRef,
        private router: Router,
        private http: HttpClient
    ) {
        this.dtx = new ProviderContext({
            ProviderCode: 'DISCOUNT',
            SortField: 'Created',
            IsAsc: false,
        });

        this.refresh(true);
    }

    public ngOnInit() {
        this.siteServices.onChangeDetail.subscribe((discount) => {
            this.refresh(true);
        });
    }

    public refresh(needCount: boolean) {
        this.rows = [];
        this.groupActionVisible = false;
        this.groupAction = null;
        this.dtx.updateFilter('JOKER', this.searchText);

        this.siteServices.provider_GetPage(this.dtx, (data) => {
            this.rows = data.TagObject;
            this.dtx.TotalItems = data.Tag;
        });
    }

    public pageChanged(ev) {
        this.dtx.Page = ev.page;
        this.refresh(false);
    }

    public onSort(_sortField) {
        if (this.dtx.SortField === _sortField) {
            this.dtx.IsAsc = !this.dtx.IsAsc;
        } else {
            this.dtx.SortField = _sortField;
            this.dtx.IsAsc = true;
        }
        this.refresh(false);
    }

    public onSortChange($ev) {
        //console.log($ev);
        const arr = $ev.target.value.split(' ');
        this.dtx.SortField = arr[0];
        this.dtx.IsAsc = arr.length === 1;

        this.dtx.SortField2 = arr[2];
        this.dtx.IsAsc2 = arr.length === 1;

        //console.log(this.dtx);
        // this.refresh(false);
    }

    public edit(id) {
        this.router
            .navigate(['discountdetail', id, Helpers.GetTicks()])
            .then((_ev) => {});
    }

    public doToggleSelect(prod: any, ev: any) {
        prod._selected = ev.target.checked;

        this.groupActionVisible =
            this.rows.filter((x) => x._selected).length > 0;
        if (!this.groupActionVisible) {
            this.groupAction = null;
        }
    }

    public toggleAll(ev: any) {
        for (const p of this.rows) {
            p._selected = ev.target.checked;
        }

        this.groupActionVisible =
            this.rows.filter((x) => x._selected).length > 0;
        if (!this.groupActionVisible) {
            this.groupAction = null;
        }
    }

    getSeletedItems() {
        return this.rows
            .filter((x) => x._selected)
            .map((y) => {
                return y.OrderID;
            });
    }

    public doFilter() {
        this.dtx.FilterList = [];
        if (this.filterStatusID)
            this.dtx.addFilter('StatusID', this.filterStatusID);
        if (this.filterDeliveryTypeID)
            this.dtx.addFilter('DeliveryTypeID', this.filterDeliveryTypeID);
        if (this.filterCreated)
            this.dtx.addFilter('Created', this.filterCreated);
        if (this.filterGen) this.dtx.addFilter('Gen', this.filterGen);

        this.refresh(true);
    }

    csvExport() {
        this.siteServices.provider_Execute(
            this.dtx.ProviderCode,
            'CSVEXPORT',
            this.dtx,
            (x) => {
                window.open(x.TagObject, '_blank');
            }
        );
    }
}
